class ModalController {
    constructor($uibModalInstance, model) {
        this.uibModalInstance = $uibModalInstance;
        this.model = model;
    }

    submit(model) {
        this.uibModalInstance.close(model);
    }

    cancel() {
        this.uibModalInstance.dismiss();
    }
}

ModalController.$inject = ['$uibModalInstance', 'model'];

export {ModalController};



// WEBPACK FOOTER //
// ./app/components/common/modal.controller.js